export const styles = {
  container: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  header: {
    justifyContent: "space-between",
    borderBottom: "1px solid #E5E5E5",
    padding: "20px 24px",
  },
  content: {
    flex: 1,
    overflow: "hidden",
    minHeight: 0,
  },
  formWrapper: {
    width: { xs: "100%", md: "45%" },
    height: "100%",
  },
};
